/* global Paddle */ // Add this comment to inform ESLint about the global Paddle object
import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { register as registerServiceWorker } from './serviceWorkerRegistration';
import './offline/install'; // captures Chrome's install prompt event early

const getSampleRate = (value, fallback) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return fallback;
  return Math.max(0, Math.min(1, parsed));
};

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
    release: process.env.REACT_APP_SENTRY_RELEASE,
    tracesSampleRate: getSampleRate(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE, 0.05),
    sendDefaultPii: false
  });
}

// --- Paddle Initialization ---
const initializePaddle = async () => {
  const paddleClientToken = process.env.REACT_APP_PADDLE_CLIENT_TOKEN;

  if (!paddleClientToken) {
    console.error('ERROR: REACT_APP_PADDLE_CLIENT_TOKEN environment variable is not set!');
    // Handle error appropriately - maybe show a message to the user
    return;
  }

  // Wait for the Paddle script (loaded in index.html) to be ready
  let attempts = 0;
  while (!window.Paddle && attempts < 60) { // Check for 30 seconds (script loads async)
      await new Promise(resolve => setTimeout(resolve, 500));
      attempts++;
  }

  if (window.Paddle) {
    try {
      const environment = paddleClientToken.startsWith('test_') ? 'sandbox' : 'live';
      console.log(`Initializing Paddle.js v2 in ${environment} mode.`);
      // Paddle.js v2 determines environment from token prefix, 'environment' is not a valid option here.
      await Paddle.Initialize({ // Use await if Initialize returns a promise (optional but safe)
        token: paddleClientToken,
        // Paddle Billing v2 only surfaces checkout lifecycle events here —
        // the v1-style successCallback/errorCallback options on
        // Checkout.open() are silently ignored. Re-dispatch as a DOM event
        // so the component that opened the checkout can react (navigate to
        // the success/failure pages, refresh credits, ...).
        eventCallback: (event) => {
          window.dispatchEvent(new CustomEvent('paddle:checkout-event', { detail: event }));
        }
      });
      console.log('Paddle.js v2 initialized successfully from src/index.js');
    } catch (error) {
       console.error('Paddle Initialize Error:', error);
       // Handle initialization error
    }
  } else {
    console.error('Paddle.js script failed to load.');
    // Handle script load error
  }
};

initializePaddle();
// --- End Paddle Initialization ---


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div>Something went wrong.</div>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Installable, offline-capable shell (see src/service-worker.js).
registerServiceWorker();
